import { notifyAnalyticsIdentityChanged } from '../../analytics/analytics-identity';
import { Injectable } from '@angular/core';
import { AES, enc } from 'crypto-js';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LocalService {

  prefixKeep = [
    'api.url',
    'export.url',
    'tenant.',
    'theme',
  ];

  constructor() { }

  public saveData(key: string, value: any) {
    if (value !== null && value !== undefined) {
      notifyAnalyticsIdentityChanged();
      localStorage.setItem(key, this.encrypt(JSON.stringify(value)));
    }
  }

  public getData(key: string) {
    if (key.startsWith('data_cache')) {
      return null;
    }

    const value = localStorage.getItem(key) || null;

    if (!value) {
      return null;
    }
    
    try {
      return JSON.parse(this.decrypt(value));
    } catch (error) {
      return this.decrypt(value);
    }
  }

  public removeData(key: string) {
    notifyAnalyticsIdentityChanged();
    localStorage.removeItem(key);
  }

  public clearData() {
    Object.keys(localStorage).forEach((key) => {
      if (!this.prefixKeep.some((prefix) => key.startsWith(prefix))) {
        notifyAnalyticsIdentityChanged();
        localStorage.removeItem(key);
      }
    });

    const fqdn = this.getData('tenant.fqdn');

    if (fqdn) {
      this.clearDataByPrefix('tenant');
    }
  }

  public clearDataByPrefix(prefix: string) {
    Object.keys(localStorage).forEach((key) => {
      if (key.startsWith(prefix)) {
        notifyAnalyticsIdentityChanged();
        localStorage.removeItem(key);
      }
    });
  }

  private encrypt(text: string) {
    return AES.encrypt(text, environment.localStorageSecretKey).toString();
  }

  private decrypt(text: string) {
    return AES.decrypt(text, environment.localStorageSecretKey).toString(enc.Utf8) || null;
  }

  private generateUrl(url: string, secure: boolean = true) {
    return `${secure ? 'https' : 'http'}://${url}`;
  }

  public initEnvironment() {
    this.saveData('api.url', this.generateUrl(environment.api.url, environment.api.secure));
    this.saveData('s3.url', this.generateUrl(environment.s3.url, environment.s3.secure));
    this.saveData('export.url', this.generateUrl(environment.export.url, environment.export.secure));
    this.saveData('stage', environment.stage);
  }
}